import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      auto: [],
      fuzzy: [],
      field: 'fulltext'
    }
  },
  methods: {
    getLabel: item => item ? item.highlighting || item.value || item : '',
    getValue: item => item ? item.value || item : '',
    getID: url => url.split('/').slice(-1)[0],
    parseData (data) {
      return data.slice(0, 5).map(({attributes: {value, highlighting}, type, relationships}) => (
        {value, highlighting, type, id: relationships ? this.getID(relationships['lei-records'].links.related) : null}
      ))
    },
    autocompleteQuery (endpoint = 'autocompletions', val, arr) {
      return this.autocomplete({endpoint, q: val || '', field: this.field})
        .then(res => {
          this[arr] = this.parseData(res ? res.data : [])
        })
    },
    focus (val) {
      if (val) this.autocompleteDebounce(val)
    },
    autocompleteDebounce: debounce(function (val) {
      this.setInputValue(val || '')
      Promise.all([
        this.autocompleteQuery('fuzzycompletions', val, 'fuzzy'),
        this.autocompleteQuery('autocompletions', val, 'auto')
      ]).catch(e => console.error(Error(e)))
    }, 500)
  },
  computed: {
    internalItems () {
      return [
        {items: this.auto},
        {
          title: this.auto.length === 0 ? 'No suggestions available. Did you mean...' : 'Or did you mean...',
          items: this.fuzzy
        }
      ].filter(({items}) => items.length !== 0)
    }
  },
  created () {
    if (!this.setInputValue) console.error('need method setInputValue')
    if (!this.autocomplete) console.error('need method autocomplete')
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/lei-shared/mixins/search-mixin.js
// module id = 1yC0
// module chunks = 0